import type { UserPrivilegeFragment } from './__types__/UserPrivilegeFragment.ts';
import { getUserPrivilegeFromQuery } from './getUserPrivilegeFromQuery.ts';
import { UserPrivilege } from './UserPrivilege.ts';

export function getIsProductOrSiteAdminFromQuery(
	queryData: UserPrivilegeFragment | undefined,
): boolean {
	const userPrivilege = getUserPrivilegeFromQuery(queryData);

	return (
		userPrivilege === UserPrivilege.PRODUCT_ADMIN || userPrivilege === UserPrivilege.SITE_ADMIN
	);
}
